import { Location } from '@angular/common';
import { IPager } from '../pager/index';


export class FiltersOptions {
    associatedList: IPager;
    location?: Location;
    filters: any[];
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/filter/filters-options.model.ts